import React, { Component } from 'react';

import get from 'lodash/get';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import { FormattedMessage } from 'react-intl';

import Text from 'ui/Text';
import axios from 'utils/axios';
import PageTitle from 'shared/PageTitle';
import WrappedForm from 'components/BaseQuestionnaire/FormLayout';
import Auth from 'shared/Auth';
import { CDRComponentMap } from '../CDRSections/CDRComponentMap';
import localStorage from 'utils/localStorage';

class QuestionnaireLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      questions: [],
      responses: [],
      loading: true,
      sectionHeading: '',
      nextSectionId: '',
      titleKey: 'title',
      valueKey: 'value',
      sectionIndex: null,
      surveyMode: Auth.isSurveyMode(),
    };
  }

  componentDidMount() {
    const sectionId = this.props.match.params.id;

    this.fetchQuestions(sectionId);

    this.fetchAnswers();
  }

  componentWillReceiveProps(newProps) {
    const sectionId = newProps.match.params.id;

    this.fetchQuestions(sectionId);

    if (this.state.surveyMode) this.fetchAnswers();
  }

  fetchQuestions = (sectionId) => {
    const sectionQuestionnaire = localStorage.getList(get(Auth.getUser(), 'current_stage_id'));

    let section = find(sectionQuestionnaire, ['id', sectionId]);
    let sectionIndex = findIndex(sectionQuestionnaire, ['id', sectionId]);

    const titleMap = {
      en_US: 'title',
      fr_FR: 'title_fr',
    };

    const valueMap = {
      en_US: 'value',
      fr_FR: 'value_fr',
    };

    const currentLanguage = get(Auth.getLanguage(), 'lang');

    const titleKey = get(titleMap, currentLanguage);

    const valueKey = get(valueMap, currentLanguage);

    if (!this.state.surveyMode) {
      section = find(CDRComponentMap, ['route', sectionId]);
      sectionIndex = findIndex(CDRComponentMap, ['route', sectionId]);
    }

    this.setState({
      questions: get(section, 'questions'),
      sectionHeading: get(section, titleKey),
      nextSectionId: this.state.surveyMode ? get(sectionQuestionnaire[sectionIndex + 1], 'id') : get(CDRComponentMap[sectionIndex + 1], 'route'),
      sectionIndex,
      titleKey,
      valueKey,
    });
  }

  fetchAnswers = () => {
    const user = Auth.getUser();

    this.setState({ loading: true });

    axios
      .get(`/response?user_id=${get(user, 'id')}`)
      .then((response) => {
        const rawResponses = get(response.data, 'returned_resultset');

        const processedResponses = {};

        rawResponses.forEach((rawResponse) => {
          let finalResponse;

          try {
            finalResponse = JSON.parse(get(rawResponse, 'response'));
          } catch (e) {
            finalResponse = get(rawResponse, 'response');
          }

          processedResponses[get(rawResponse, 'question_id')] = finalResponse;
        });

        this.setState({
          loading: false,
          responses: processedResponses,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  }

  render() {
    const {
      sectionHeading, questions, responses, loading, 
      nextSectionId, titleKey, valueKey, sectionIndex,
    } = this.state;

     (nextSectionId);

    return (
      <div className="questionnaire-container">
        <PageTitle title={sectionHeading} />
        {
          loading ? (
            <Text type="sub-head" modifiers="text-center">
              {
                questions && questions.length ? (
                  <FormattedMessage
                    id="Questionnaire.LoadingQuestions"
                    defaultMessage="Preparing Questions. Kindly Wait..."
                  />
                ) : null
              }
            </Text>
          ) : (
            <WrappedForm
              {...this.props}
              valueKey={valueKey}
              titleKey={titleKey}
              questions={questions}
              nextSectionId={nextSectionId}
              responses={responses}
              sectionIndex={sectionIndex}
            />
          )
        }
      </div>
    );
  }
}

export default QuestionnaireLayout;



// WEBPACK FOOTER //
// ./src/components/BaseQuestionnaire/QuestionnaireLayout.js